import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";

import {
  WithStyles,
  createStyles,
  Typography,
  Button,
  Modal,
  Card,
  CardContent,
  CardActions,
  CardHeader,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Paper,
  Link,
  TableHead,
  Table,
  TableBody,
  TextField,
  TableRow
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";

import {
  MyPATCollapse,
  MyPATLink,
  dateService,
  MyPATDialog
} from "../../common";
import { BorderAll } from "@material-ui/icons";
import PerfectScrollbar from "react-perfect-scrollbar";
import { parseTime } from "../../../utils/getOffset.utils";

const styles = (theme: Theme) =>
  createStyles({
    QuestionAnalyticsCard: {
      borderRadius: 4,
      width: "100%",
      margin: "0",
      "&>:first-child": {
        paddingLeft: 0,
        paddingRight: 0,
        paddingBottom: "12px"
      },
      "& table": {
        textAlign: "center",
        // width: "500px",
        borderRadius: 4,
        // borderCollapse: "inherit",
        "& thead": {
          backgroundColor: "#F1F1F1",
          "& td": {
            fontSize: "12px",
            padding: "7px 5px",
            color: "#333",
            fontWeight: 600,
            border: "1px solid #D8D0D0"
          }
        },
        "& tbody": {
          "& tr": {
            "&:last-child": {
              borderBottom: "none"
            },
            "& td": {
              fontSize: "12px",
              padding: "7px 5px",
              color: "#666",
              border: "1px solid #D8D0D0"
            }
          }
        }
      }
    },
    textRight: {
      textAlign: "right"
    },
    textCenter: {
      textAlign: "center"
    },
    textTruncate: {
      // textOverflow: 'ellipsis',
      // whiteSpace: 'nowrap',
      // overflow: 'hidden',
      // width: '110px',
      // display: 'inline-block',
    },
    perfectScrollbar: {
      ...theme.mixins.gutters(),
      paddingTop: theme.spacing.unit,
      // paddingBottom: theme.spacing.unit,
      maxHeight: "200px",
      background: "rgb(255, 255, 255)",
      borderRadius: 4,
      "& .ps--active-x > .ps__rail-x, .ps--active-y > .ps__rail-y": {
        opacity: 1
      },
      paddingBottom: 24
    }
  });

//@ts-ignore
interface QuestionAnalyticsProps extends WithStyles<typeof styles> {
  classes: any;
  content: any;
}
class QuestionAnalytics extends Component<QuestionAnalyticsProps> {
  constructor(props: QuestionAnalyticsProps) {
    super(props);
  }

  handleDialogClose = () => {
    //add your code
  };
  addQuestionAnalytics() {
    //add your code
  }
  renderAnalytics() {
    //add your code
    const { content: c, classes } = this.props;
    if (c) {
      if (c.data.analyticsData && c.data.analyticsData.length) {
        const analytics = c.data.analyticsData.map((item: any, index: number) => (
          <tr>
            <td>{index + 1}</td>
            <td>
              <span className={classes.textTruncate}>{item.contentId}</span>
            </td>
            <td>{item.testAttemptCount}</td>
            <td>{Math.floor(item.attemptPercentage)}%</td>
            <td>{Math.floor(item.correctPercentage)}%</td>
            <td>{parseTime(item.avgTimeToSolve)}</td>
          </tr>
        ));
        return (
          <Table>
            <thead>
              <td>S.No</td>
              <td>Test ID</td>
              <td>No. of Attempts</td>
              <td>Attempt %</td>
              <td>Accuracy %</td>
              <td>Avg. Time Taken</td>
            </thead>
            <tbody>{analytics}</tbody>
          </Table>
        );
      } else return c.message;
    } else return "";
  }
  render() {
    const { classes } = this.props;
    return (
      <>
        {/* <MyPATCollapse title="Question Analytics"> */}
          <Grid container direction="row" justify="center" alignItems="center">
            <Grid className={classes.QuestionAnalyticsCard}>
              <PerfectScrollbar
                className={classes.perfectScrollbar}
              >
                {/* <Table>
                  <thead>
                    <td>S.No</td>
                    <td>Test ID</td>
                    <td>No. of Attempts</td>
                    <td>Attempt %</td>
                    <td>Correct Ques. %</td>
                    <td>Avg. Time Taken</td>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>
                        <span className={classes.textTruncate}>T-12345</span>
                      </td>
                      <td>100</td>
                      <td>45%</td>
                      <td>45%</td>
                      <td>1m 34s</td>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>
                        <span className={classes.textTruncate}>T-12345</span>
                      </td>
                      <td>100</td>
                      <td>45%</td>
                      <td>45%</td>
                      <td>1m 34s</td>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>
                        <span className={classes.textTruncate}>T-12345</span>
                      </td>
                      <td>100</td>
                      <td>45%</td>
                      <td>45%</td>
                      <td>1m 34s</td>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>
                        <span className={classes.textTruncate}>T-12345</span>
                      </td>
                      <td>100</td>
                      <td>45%</td>
                      <td>45%</td>
                      <td>1m 34s</td>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>
                        <span className={classes.textTruncate}>T-12345</span>
                      </td>
                      <td>100</td>
                      <td>45%</td>
                      <td>45%</td>
                      <td>1m 34s</td>
                    </tr>
                  </tbody>
                </Table>
                 */}
                {this.renderAnalytics()}
              </PerfectScrollbar>
            </Grid>
          </Grid>
        {/* </MyPATCollapse> */}
      </>
    );

    // {isOpenQuestionAnalyticsDialog && this.handleQuestionAnalytics()}
  }
}

// @ts-ignore
export default withStyles(styles)(QuestionAnalytics);
